var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 132.161C109.703 132.161 132.161 109.703 132.161 82C132.161 54.2968 109.703 31.8388 82 31.8388C54.2968 31.8388 31.8389 54.2968 31.8389 82C31.8389 109.703 54.2968 132.161 82 132.161ZM82 129.158C108.044 129.158 129.158 108.044 129.158 82C129.158 55.9556 108.044 34.8425 82 34.8425C55.9557 34.8425 34.8425 55.9556 34.8425 82C34.8425 108.044 55.9557 129.158 82 129.158Z",
    fill: "url(#paint0_linear_258_11331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4823 24.2751L79.2342 24.3284L79.1698 19.1961L73.8207 11.1695L78.703 11.1083L81.2956 15.4782L81.3725 15.4773L83.8545 11.0436L88.487 10.9855L83.4179 19.1428L83.4823 24.2751Z",
    fill: "url(#paint1_linear_258_11331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0149 26.008L65.2843 16.552L69.4398 15.352L68.5011 12.1015L56.0901 15.6855L57.0287 18.936L61.2027 17.7306L63.9333 27.1867L68.0149 26.008Z",
    fill: "url(#paint2_linear_258_11331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7347 24.1297L50.5324 18.2277L52.1691 20.9447L46.0105 24.6545L46.9529 26.2189L52.2222 23.0447L53.7894 25.6464L48.5201 28.8206L49.5616 30.5496L55.8354 26.7704L57.4721 29.4874L47.5591 35.4587L40.7347 24.1297Z",
    fill: "url(#paint3_linear_258_11331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6147 28.1639L28.1159 35.7802L37.5404 45.0592L40.521 42.0318L37.1375 38.7006L41.0217 34.7555L38.8574 32.6245L34.9732 36.5696L33.3568 34.9782L37.8749 30.3893L35.6147 28.1639Z",
    fill: "url(#paint4_linear_258_11331)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4902 50.8879L31.5946 50.4469L29.2963 54.4695L30.6388 55.8786L28.4835 59.6508L19.3937 48.9001L21.8446 44.6105L35.7217 46.9822L33.4902 50.8879ZM27.1645 52.233L28.5855 49.7461L23.8095 48.6114L23.7714 48.6781L27.1645 52.233Z",
    fill: "url(#paint5_linear_258_11331)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2722 64.3231C13.6915 62.6842 14.3715 61.4229 15.312 60.5392C16.24 59.6522 17.3591 59.3631 18.6691 59.6719L18.8925 59.7291L17.9061 63.5841L17.8316 63.5651C17.4591 63.4697 17.1138 63.5269 16.7956 63.7365C16.4774 63.9461 16.2468 64.3302 16.1038 64.8889C15.964 65.4352 15.9367 65.878 16.0219 66.2173C16.1102 66.5442 16.2723 66.7378 16.5082 66.7981C16.8434 66.8839 17.1426 66.7488 17.4056 66.3928C17.6687 66.0368 17.9999 65.4403 18.3993 64.6033C18.8741 63.6268 19.3136 62.8397 19.7179 62.242C20.1129 61.6288 20.6347 61.1406 21.2832 60.7774C21.9318 60.4142 22.7046 60.3408 23.6017 60.5571C25.1164 60.9447 26.1081 61.7475 26.577 62.9654C27.049 64.1709 27.0658 65.6304 26.6273 67.3437C26.1158 69.3426 25.3819 70.815 24.4255 71.7608C23.4723 72.6943 22.1453 72.9433 20.4443 72.5081L21.4403 68.6158C22.0859 68.781 22.5634 68.7246 22.8726 68.4466C23.1695 68.1654 23.4084 67.6709 23.5895 66.9632C23.723 66.4418 23.7767 65.9991 23.7507 65.6353C23.728 65.2591 23.5427 65.0265 23.1951 64.9375C22.8847 64.8581 22.6058 64.9918 22.3583 65.3385C22.1016 65.6697 21.7767 66.2414 21.3837 67.0536C20.8933 68.0393 20.4428 68.8434 20.0322 69.4659C19.6092 70.0852 19.0532 70.5779 18.3642 70.944C17.6752 71.3101 16.8528 71.3708 15.8968 71.1261C14.4938 70.7671 13.6015 69.9634 13.2199 68.7148C12.829 67.4507 12.8465 65.9868 13.2722 64.3231Z",
    fill: "url(#paint6_linear_258_11331)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.682 18.2653L103.763 14.2857L98.8383 26.5604L102.781 28.1423L104.549 23.7355L109.687 25.7969L110.818 22.978L105.68 20.9166L106.525 18.8113L112.501 21.2091L113.682 18.2653Z",
    fill: "url(#paint7_linear_258_11331)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.7 32.4564L118.918 21.3741L122.478 23.6928L115.26 34.775L111.7 32.4564Z",
    fill: "url(#paint8_linear_258_11331)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.04 40.5919C132.811 40.4419 133.483 40.083 134.057 39.5151C134.576 39.0013 134.933 38.4051 135.127 37.7264C135.339 37.0479 135.333 36.341 135.111 35.6058C134.906 34.8707 134.47 34.1661 133.803 33.492L128.111 27.7393L118.71 37.0419L121.698 40.0617L125.128 36.6679L126.236 37.7884L124.456 42.8493L127.81 46.238L129.676 40.2533C130.481 40.6291 131.269 40.7419 132.04 40.5919ZM131.263 35.7079C131.262 36.0341 131.138 36.3189 130.892 36.5623C130.646 36.8057 130.355 36.931 130.02 36.9383C129.694 36.9366 129.413 36.8173 129.179 36.5805L127.218 34.5991L128.954 32.8819L130.914 34.8633C131.149 35.1001 131.265 35.3817 131.263 35.7079Z",
    fill: "url(#paint9_linear_258_11331)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.961 47.0172C144.789 48.4923 145.168 49.8742 145.098 51.1628C145.039 52.4452 144.429 53.427 143.268 54.1081L143.067 54.221L141.119 50.7511L141.186 50.7135C141.521 50.5253 141.731 50.2455 141.817 49.8742C141.902 49.5029 141.804 49.0658 141.521 48.5629C141.245 48.0712 140.96 47.732 140.664 47.5454C140.374 47.3699 140.123 47.3418 139.911 47.461C139.609 47.6304 139.486 47.9347 139.541 48.3738C139.597 48.813 139.769 49.4732 140.058 50.3544C140.389 51.3886 140.614 52.2614 140.735 52.9729C140.872 53.6893 140.832 54.4027 140.613 55.1132C140.395 55.8237 139.887 56.4104 139.088 56.8733C137.725 57.6387 136.453 57.7427 135.273 57.1853C134.099 56.6391 133.08 55.595 132.214 54.0528C131.204 52.2536 130.718 50.6818 130.757 49.3372C130.802 48.0039 131.59 46.9075 133.121 46.048L135.088 49.5513C134.507 49.8776 134.2 50.248 134.169 50.6627C134.148 51.071 134.317 51.5937 134.674 52.2307C134.938 52.7 135.204 53.0573 135.474 53.3026C135.751 53.559 136.045 53.5994 136.358 53.4238C136.637 53.2669 136.747 52.9776 136.687 52.5559C136.644 52.1391 136.484 51.5013 136.207 50.6424C135.882 49.5907 135.652 48.698 135.52 47.9642C135.398 47.2241 135.46 46.4838 135.706 45.7433C135.951 45.0028 136.505 44.391 137.365 43.9079C138.628 43.199 139.828 43.1644 140.966 43.8041C142.122 44.4487 143.12 45.5198 143.961 47.0172Z",
    fill: "url(#paint10_linear_258_11331)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.328 69.4958L147.863 67.0558L148.935 71.2461L152.213 70.4074L149.01 57.8925L145.733 58.7312L146.81 62.9401L137.274 65.38L138.328 69.4958Z",
    fill: "url(#paint11_linear_258_11331)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.811 99.4018C150.391 101.041 149.711 102.302 148.771 103.186C147.843 104.073 146.724 104.362 145.414 104.053L145.19 103.996L146.177 100.141L146.251 100.16C146.624 100.255 146.969 100.198 147.287 99.9884C147.605 99.7788 147.836 99.3947 147.979 98.836C148.119 98.2897 148.146 97.8469 148.061 97.5076C147.973 97.1808 147.811 96.9872 147.575 96.9268C147.239 96.841 146.94 96.9761 146.677 97.3321C146.414 97.6881 146.083 98.2846 145.684 99.1217C145.209 100.098 144.769 100.885 144.365 101.483C143.97 102.096 143.448 102.584 142.8 102.948C142.151 103.311 141.378 103.384 140.481 103.168C138.966 102.78 137.975 101.977 137.506 100.76C137.034 99.554 137.017 98.0946 137.456 96.3812C137.967 94.3823 138.701 92.9099 139.657 91.9641C140.611 91.0307 141.938 90.7816 143.639 91.2168L142.643 95.1091C141.997 94.9439 141.519 95.0003 141.21 95.2784C140.913 95.5596 140.674 96.054 140.493 96.7617C140.36 97.2832 140.306 97.7258 140.332 98.0896C140.355 98.4658 140.54 98.6984 140.888 98.7874C141.198 98.8668 141.477 98.7331 141.725 98.3864C141.981 98.0552 142.306 97.4835 142.699 96.6713C143.19 95.6856 143.64 94.8815 144.051 94.259C144.474 93.6397 145.03 93.147 145.719 92.7809C146.408 92.4149 147.23 92.3541 148.186 92.5988C149.589 92.9578 150.481 93.7616 150.863 95.0101C151.254 96.2742 151.236 97.7381 150.811 99.4018Z",
    fill: "url(#paint12_linear_258_11331)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.488 113.278L130.593 112.837L128.361 116.743L142.238 119.114L144.689 114.825L135.599 104.074L133.444 107.846L134.787 109.255L132.488 113.278ZM135.497 113.979L136.918 111.492L140.311 115.047L140.273 115.114L135.497 113.979Z",
    fill: "url(#paint13_linear_258_11331)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.967 127.945L128.468 135.561L126.208 133.336L130.726 128.747L129.11 127.155L125.225 131.1L123.061 128.969L126.945 125.024L123.562 121.693L126.542 118.666L135.967 127.945Z",
    fill: "url(#paint14_linear_258_11331)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.55 145.497L123.348 139.595L116.524 128.266L106.611 134.238L108.247 136.955L114.521 133.175L115.563 134.904L110.293 138.079L111.861 140.68L117.13 137.506L118.072 139.07L111.914 142.78L113.55 145.497Z",
    fill: "url(#paint15_linear_258_11331)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7986 147.173L96.0679 137.717L100.15 136.538L102.88 145.994L107.054 144.789L107.993 148.039L95.5817 151.623L94.6431 148.373L98.7986 147.173Z",
    fill: "url(#paint16_linear_258_11331)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8486 139.397L80.6006 139.45L80.665 144.582L75.5958 152.739L80.2283 152.681L82.7104 148.248L82.7873 148.247L85.3798 152.617L90.2622 152.555L84.913 144.529L84.8486 139.397Z",
    fill: "url(#paint17_linear_258_11331)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3201 149.439L50.4003 145.46L51.5813 142.516L57.5582 144.914L58.4028 142.808L53.2645 140.747L54.3954 137.928L59.5337 139.99L61.3016 135.583L65.2445 137.165L60.3201 149.439Z",
    fill: "url(#paint18_linear_258_11331)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1649 142.351L52.3831 131.269L48.8232 128.95L41.605 140.032L45.1649 142.351Z",
    fill: "url(#paint19_linear_258_11331)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0258 124.21C30.5997 123.642 31.2721 123.283 32.0432 123.133C32.8143 122.983 33.6021 123.096 34.4067 123.472L36.2732 117.487L39.6265 120.876L37.8464 125.937L38.9551 127.057L42.3849 123.663L45.3731 126.683L35.972 135.986L30.2795 130.233C29.6124 129.559 29.1766 128.854 28.9721 128.119C28.7494 127.384 28.7441 126.677 28.9561 125.999C29.1499 125.32 29.5065 124.724 30.0258 124.21ZM33.191 127.163C32.9451 127.406 32.8212 127.691 32.8195 128.017C32.8178 128.343 32.9341 128.625 33.1685 128.862L35.1291 130.843L36.8644 129.126L34.9039 127.145C34.6695 126.908 34.3892 126.788 34.063 126.787C33.7276 126.794 33.437 126.919 33.191 127.163Z",
    fill: "url(#paint20_linear_258_11331)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9853 112.562C18.9151 113.851 19.2941 115.233 20.1223 116.708C20.9629 118.205 21.961 119.276 23.1166 119.921C24.2547 120.561 25.4551 120.526 26.7179 119.817C27.5784 119.334 28.1314 118.722 28.3771 117.982C28.6227 117.241 28.6848 116.501 28.5632 115.761C28.4305 115.027 28.2012 114.134 27.8754 113.083C27.5989 112.224 27.4392 111.586 27.3963 111.169C27.3359 110.747 27.4454 110.458 27.7248 110.301C28.0377 110.126 28.3322 110.166 28.6085 110.422C28.8785 110.668 29.1452 111.025 29.4087 111.494C29.7663 112.131 29.9348 112.654 29.9142 113.062C29.8824 113.477 29.576 113.847 28.9949 114.174L30.9617 117.677C32.4927 116.818 33.2807 115.721 33.3258 114.388C33.3646 113.043 32.879 111.471 31.8689 109.672C31.0032 108.13 29.9834 107.086 28.8096 106.54C27.6296 105.982 26.3579 106.086 24.9945 106.852C24.1962 107.315 23.6878 107.901 23.4694 108.612C23.251 109.322 23.2107 110.036 23.3483 110.752C23.4685 111.464 23.6939 112.336 24.0247 113.371C24.3137 114.252 24.4859 114.912 24.5414 115.351C24.5969 115.79 24.4737 116.095 24.172 116.264C23.9597 116.383 23.7087 116.355 23.4192 116.18C23.1233 115.993 22.8374 115.654 22.5613 115.162C22.279 114.659 22.1806 114.222 22.2661 113.851C22.3516 113.479 22.5619 113.2 22.8972 113.011L22.9642 112.974L21.0162 109.504L20.8151 109.617C19.6543 110.298 19.0443 111.28 18.9853 112.562Z",
    fill: "url(#paint21_linear_258_11331)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2201 96.6691L25.7552 94.2291L26.8084 98.3449L17.2733 100.785L18.3503 104.994L15.0726 105.832L11.8701 93.3176L15.1478 92.4788L16.2201 96.6691Z",
    fill: "url(#paint22_linear_258_11331)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.172 84.1025C19.2503 84.1025 20.1244 83.2284 20.1244 82.1502C20.1244 81.0719 19.2503 80.1978 18.172 80.1978C17.0938 80.1978 16.2197 81.0719 16.2197 82.1502C16.2197 83.2284 17.0938 84.1025 18.172 84.1025Z",
    fill: "url(#paint23_linear_258_11331)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.78 82.1502C147.78 83.2284 146.906 84.1025 145.827 84.1025C144.749 84.1025 143.875 83.2284 143.875 82.1502C143.875 81.0719 144.749 80.1978 145.827 80.1978C146.906 80.1978 147.78 81.0719 147.78 82.1502Z",
    fill: "url(#paint24_linear_258_11331)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 164C127.287 164 164 127.287 164 82C164 36.7127 127.287 0 82 0C36.7127 0 0 36.7127 0 82C0 127.287 36.7127 164 82 164ZM82 160.996C125.628 160.996 160.996 125.628 160.996 82C160.996 38.3715 125.628 3.00366 82 3.00366C38.3715 3.00366 3.00366 38.3715 3.00366 82C3.00366 125.628 38.3715 160.996 82 160.996Z",
    fill: "url(#paint25_linear_258_11331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_258_11331",
    x1: 116.026,
    y1: -0.630242,
    x2: -6.77636,
    y2: 55.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3ADA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.057605dbfcc5803913b03ebb24fc25f8.svg";
export { ForwardRef as ReactComponent };